import { get, writable } from 'svelte/store';

type Device = {
  resolution: string;
  width: string;
  height: string;
  ppi: string;
  scaleFactor: string;
  cleanup?: () => void;
};

export const userDevice = (() => {
  const { subscribe, update } = writable<Device>({
    resolution: '',
    width: '',
    height: '',
    ppi: '',
    scaleFactor: ''
  });

  return {
    subscribe,
    update,
    cleanup: () => {
      const { cleanup } = get(userDevice);
      cleanup?.();
    }
  };
})();
